import { useMemo } from "react";
import { useFirestore } from "@/hooks/firestore/core/useFirestore";
import { withdrawal } from "@/hooks/firestore/models/withdrawal";
import { orderBy } from "firebase/firestore";

const useWithdrawals = () => {
  const {
    data: withdrawals,
    isLoading,
    error,
  } = useFirestore(`/users/{userId}/withdrawals`, withdrawal.array(), {
    keyPath: "id",
    query: [orderBy("createdAt", "desc")],
  });

  // exclude non cancellable items
  const filteredWithdrawals = useMemo(() => {
    if (!withdrawals) return;

    return (withdrawals || []).filter(
      (withdrawal) => withdrawal.status === "PENDING" && withdrawal.cancellable,
    );
  }, [withdrawals]);

  return {
    withdrawals: filteredWithdrawals,
    isLoading,
    error,
  };
};

type Withdrawal = Exclude<
  ReturnType<typeof useWithdrawals>["withdrawals"],
  undefined
>[0];

export { useWithdrawals };
export type { Withdrawal };
